// extracted by mini-css-extract-plugin
export default {"bigImg":"newsDescription_bigImg__wg4Sn","title":"newsDescription_title__NTT-S","titleMore":"newsDescription_titleMore__8FuSd","description":"newsDescription_description__TY2fv"};